// Resolves the literal icon path strings carried in the catalogs (LEADING_INDICATORS ~655-861,
// LAGGING ~863-868, TOOLS16 ~881-889, CUSTOM_ICON ~907 of docs/discovery-calculator.dc.html)
// to hashed Vite asset URLs. The catalogs keep the raw strings on purpose: localStorage
// snapshots written by the original artifact (`clay-value-story-v1`) contain them verbatim.

import ads from '../assets/icons/Ads.png';
import assistant from '../assets/icons/Assistant.png';
import automation from '../assets/icons/Automation.png';
import buildCampaign from '../assets/icons/Build-campaign.png';
import crm from '../assets/icons/CRM.png';
import customerExpansion from '../assets/icons/Customer-Expansion.png';
import emailReply from '../assets/icons/Email-reply.png';
import findPeople from '../assets/icons/Find-People.png';
import growthChart from '../assets/icons/Growth-chart.png';
import heart from '../assets/icons/Heart.png';
import inbound from '../assets/icons/Inbound.png';
import listBuilding from '../assets/icons/List-Building.png';
import loopSystemUpdate from '../assets/icons/Loop-system-update.png';
import noEmails from '../assets/icons/No-emails.png';
import outbound from '../assets/icons/Outbound.png';
import power from '../assets/icons/Power.png';
import research from '../assets/icons/Research.png';
import scheduling from '../assets/icons/Scheduling.png';
import scoreAccounts from '../assets/icons/Score-Accounts.png';
import signalJobChange from '../assets/icons/Signal-Job-Change.png';
import signalsSatellite from '../assets/icons/Signals-satellite.png';
import target from '../assets/icons/Target.png';
import toolbox from '../assets/icons/Toolbox.png';
import trophy from '../assets/icons/Trophy.png';
import clayLogoPrimaryBlk from '../assets/logo/Clay_Logo_Primary_Blk.png';
import sixSense from '../assets/provider-icons/6Sense.svg';
import apollo from '../assets/provider-icons/Apollo.svg';
import clearbit from '../assets/provider-icons/Clearbit.svg';
import leadIq from '../assets/provider-icons/LeadIQ.svg';
import lusha from '../assets/provider-icons/Lusha.svg';
import outreach from '../assets/provider-icons/Outreach.svg';
import zoomInfo from '../assets/provider-icons/ZoomInfo.svg';

/** Catalog path string → bundled asset URL. Keys must match the catalog strings exactly. */
export const ICON_URLS: Record<string, string> = {
  'assets/icons/Ads.png': ads,
  'assets/icons/Assistant.png': assistant,
  'assets/icons/Automation.png': automation,
  'assets/icons/Build-campaign.png': buildCampaign,
  'assets/icons/CRM.png': crm,
  'assets/icons/Customer-Expansion.png': customerExpansion,
  'assets/icons/Email-reply.png': emailReply,
  'assets/icons/Find-People.png': findPeople,
  'assets/icons/Growth-chart.png': growthChart,
  'assets/icons/Heart.png': heart,
  'assets/icons/Inbound.png': inbound,
  'assets/icons/List-Building.png': listBuilding,
  'assets/icons/Loop-system-update.png': loopSystemUpdate,
  'assets/icons/No-emails.png': noEmails,
  'assets/icons/Outbound.png': outbound,
  'assets/icons/Power.png': power,
  'assets/icons/Research.png': research,
  'assets/icons/Scheduling.png': scheduling,
  'assets/icons/Score-Accounts.png': scoreAccounts,
  'assets/icons/Signal-Job-Change.png': signalJobChange,
  'assets/icons/Signals-satellite.png': signalsSatellite,
  'assets/icons/Target.png': target,
  'assets/icons/Toolbox.png': toolbox,
  'assets/icons/Trophy.png': trophy,
  'assets/logo/Clay_Logo_Primary_Blk.png': clayLogoPrimaryBlk,
  'assets/provider-icons/6Sense.svg': sixSense,
  'assets/provider-icons/Apollo.svg': apollo,
  'assets/provider-icons/Clearbit.svg': clearbit,
  'assets/provider-icons/LeadIQ.svg': leadIq,
  'assets/provider-icons/Lusha.svg': lusha,
  'assets/provider-icons/Outreach.svg': outreach,
  'assets/provider-icons/ZoomInfo.svg': zoomInfo,
};

/**
 * Bundled URL for a catalog icon path. Unknown paths pass through unchanged — restored
 * localStorage snapshots can name assets this build no longer ships.
 */
export function iconUrl(path: string): string {
  return ICON_URLS[path] ?? path;
}
